import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import TopBar from "../user-topbar/UserTopbar";
import SideBar from "../user-sidebar/UserSidebar";
import { fetchActionsUtil, useCookie } from "../../../utils";
import { URLS } from "../../urls";
import { Dropdown, Nav, Tab } from "react-bootstrap";
import "../../attendance/attendance.css";
import { LoanScheduleComponent } from "../../custom-report/LoanScheduleComponent";
import { PayeeScheduleComponent } from "../../custom-report/PayeeScheduleComponent";
import { LeaveScheduleComponent } from "../../custom-report/LeaveSchedueComponent";

const UserCustomReports = () => {
  const branch_id = useCookie("branch_id");

  const [stateBranch, setStateBranch] = useState({
    id: "",
    name: "",
  });
  const [branches, setBranches] = useState([]);

  useEffect(() => {
    const fetchBranches = async () => {
      try {
        const branchData = await fetchActionsUtil(
          `${URLS.backendBranch}/get`,
          "GET"
        );

        setBranches(branchData.branches);
        const branch = branchData.branches?.find((el) => el._id === branch_id);

        setStateBranch({ id: branch?._id, name: branch?.name });
      } catch (error) {
        console.log(error);
      }
    };

    let isMounted = true;

    if (isMounted) {
      fetchBranches();
    }

    return () => {
      isMounted = false;
    };
  }, [branch_id]);

  const switchCompany = (item) => {
    setStateBranch({ id: item._id, name: item.name });
  };

  const SwitchCompanyComponent = () => {
    return (
      <div className="my-3 d-flex justify-content-end align-item-baseline">
        <Dropdown>
          <Dropdown.Toggle variant="white" bsPrefix={`toggle`}>
            {stateBranch.name || "Switch Company"}
          </Dropdown.Toggle>
          <Dropdown.Menu
            popperConfig={{
              strategy: "fixed",
            }}
            renderOnMount
          >
            {branches?.map((el) => (
              <Dropdown.Item
                key={el.name}
                as="button"
                className={`${stateBranch.id === el._id ? "active" : ""}`}
                onClick={() => switchCompany(el)}
              >
                {el.name}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </div>
    );
  };

  return (
    <body>
      <Helmet>
        <meta charSet="utf-8" />
        <meta name="robots" content="noindex, nofollow"></meta>
        <title>InvexERP</title>
      </Helmet>
      <div className="main-wrapper">
        <TopBar />
        <SideBar />
        <section className="bg-white page-header position-relative w-100 page-header-2">
          <div className="page-wrapper">
            <div className="d-flex w-100  m-0 p-0 align-items-center justify-content-between gap-5">
              <div className="">
                <h4 className="page-title page-title-alt fw-bold">
                  Custom Report
                </h4>
                <p className="page-paragraph">
                  All Custom Report are listed here.
                </p>
              </div>
            </div>
          </div>
        </section>
        <div className="page-wrapper" style={{ paddingTop: 15 }}>
          <div className="content container-fluid">
            <Tab.Container id="left-tabs-example" defaultActiveKey="payE">
              <Nav variant="pills">
                <Nav.Item>
                  <Nav.Link eventKey="payE">
                    <span className="fw-bold">Payee Schedule</span>
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="loan">
                    <span className="fw-bold">Loans Schedule</span>
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="leave">
                    <span className="fw-bold">Leave Schedule</span>
                  </Nav.Link>
                </Nav.Item>
              </Nav>

              <Tab.Content className="pt-2">
                <Tab.Pane eventKey="payE">
                  <PayeeScheduleComponent
                    branch_id={stateBranch.id}
                    SwitchCompanyComponent={SwitchCompanyComponent}
                  />
                </Tab.Pane>
                <Tab.Pane eventKey="loan">
                  <LoanScheduleComponent
                    branch_id={stateBranch.id}
                    SwitchCompanyComponent={SwitchCompanyComponent}
                  />
                </Tab.Pane>
                <Tab.Pane eventKey="leave">
                  <LeaveScheduleComponent
                    branch_id={stateBranch.id}
                    SwitchCompanyComponent={SwitchCompanyComponent}
                  />
                </Tab.Pane>
              </Tab.Content>
            </Tab.Container>
          </div>
        </div>
      </div>
    </body>
  );
};

export default UserCustomReports;
